import React from "react";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useForm ,Controller} from "react-hook-form";
import Axios from "axios";
import { useState,useEffect } from 'react';
import defaultimg from "../../assets/images/icons8-circled-user-male-skin-type-3-100.png"
import { AddBenchCandidatesProfile,GetCountries,GetCourseInfo,GetJobRoles,GetListOfVendorsByEmployeeID,GetDocumentTypes, GetJobPosts, usStates, usStateCities,IndiaStates,IndiaStateCities, SaveCandidateRecordedAudio,GetListOfUsersByEmployeeID } from "../../apiconstants/constants";
import Swal from 'sweetalert2';
import LoadingSpinner from "../../helpers/loadingspinner";
import "../../consultant/addeditcandidate/cadidatestyles.css"
import ConsultantLayout from "../../commonlayouts/consultantlayout";
import { Link, useNavigate } from "react-router-dom";
import Select from 'react-select';
import { useCountry } from "../../contexts/countrycodecontext.js";
import Modal from 'react-bootstrap/Modal';
import mammoth from "mammoth";

const AddInternalCandidate = ()=>{

    const { register, handleSubmit,formState,reset,control,setValue,watch} = useForm();
    const { errors } = formState
    const navigate = useNavigate();
    const { isSubmitting } = formState;
    const [isDisabled, setIsDisabled] = useState(false);
    const [Courses,SetCourses]=useState([{}]);
    const [jobRoles,SetJobRoles]=useState([{}]);
    const [Countries,SetCountries]=useState([{}]);
    const [file, setFile] = useState();
    const[fileName,setFileName] = useState(null);
    const {selectedCountry} = useCountry();
    const [isLoading, setIsLoading] = useState(false);
    const [photoURL, setPhotoURL] = useState(null);
    const [visaCopy, setVisaCopy] = useState();
    const[visaCopyName,setVisaCopyName] = useState(null);
    const [drivingLicence, setDrivingLicence] = useState();
    const[drivingLicenceName,setDrivingLicenceName] = useState(null);
    const [maskedResumeCopy, setMaskedResumeCopy] = useState();
    const[maskedResumeName,setMaskedResumeName] = useState(null);
    const [imgfile, setimgFile] = useState();
    const [consultantDet,setConsultantDet] = useState([{}])
    const [vendorData, setVendorData] = useState([]);
    const [workmode,setWorkMode] = useState([
      {statusID:"1",statusName:"Work from Home"},
      {statusID:"2",statusName:"Work from Office"},
      {statusID:"3",statusName:"Hybrid"}]);
          const [marketingStatus,setMarketingStatus] = useState([
      {statusID:"Active",statusName:"Active"},
      {statusID:"Hold",statusName:"Hold"},
      {statusID:"Pending",statusName:"Pending"},
    {statusID:"Deactivate",statusName:"Deactivate"}]);
      const [candidateType,setCandidateType] = useState([
      {candidateTypeID:"Internal Bench",typeName:"Internal Bench"},
      {candidateTypeID:"C2C",typeName:"C2C"},
      {candidateTypeID:"W2",typeName:"W2"},
    {candidateTypeID:"1099",typeName:"1099"}]);
      const [preferLocation, setPreferLocation] = useState('');
      const billRatePlaceholder = selectedCountry == 1 ? 'Expected CTC' : 'Bill Rate';
      const payRatePlaceholder = selectedCountry == 1 ? ' Current CTC' : 'Pay Rate';
  const [documents,SetDocuments] =useState([{}]);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState(null);
  const [jobPosts, setJobPosts] = useState([]);
const [showAssessmentModal, setShowAssessmentModal] = useState(false);
const [assessmentMode, setAssessmentMode] = useState(""); // "link" or "file"
const [assessmentFile, setAssessmentFile] = useState(null);
const [usersData, setUsersData] = useState([]);
const [benchSalesUsers, setBenchSalesUsers] = useState([]);
const isEmptySkill = (skill) =>
  !skill?.Skill && !skill?.YearsOfExp && !skill?.Rating;



const token = localStorage.getItem("jwtToken");

const documentLabels = {
  FileUrl: "Resume",
  VisaCopyUrl: "VisaCopy",
  DrivingLicenceUrl: "DrivingLicence",
  PassportURL: "Passport",
  I94File: "I-94",
  RTR_PDFDoc:"RTR_PDF",
  Resume_Insights_Pdfdoc:"Resume_Insights_Pdf",
  OthersDoc:"Others"
};
const [showModal1, setShowModal1] = useState(false);
const [modalContent, setModalContent] = useState({
  title: '',
  url: '',
});
const GetUsersList = () => {
  setIsLoading(true);

  const GetapiUrl =
    GetListOfUsersByEmployeeID.APIURL + `?EmployeeGuid=${Guid}`;

  Axios.get(GetapiUrl, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((result) => {
      setIsLoading(false);

   const benchUsers = result.data.filter((u) => {
  if (!u.usertype) return false;

  // Handle: "Bench Sales", "Recruiter, Bench Sales", etc.
  if (typeof u.usertype === "string") {
    return u.usertype
      .split(",")
      .map((t) => t.trim().toLowerCase())
      .includes("bench sales");
  }

  // Handle: ["Recruiter", "Bench Sales"]
  if (Array.isArray(u.usertype)) {
    return u.usertype
      .map((t) => t.toLowerCase())
      .includes("bench sales");
  }

  return false;
});


      setBenchSalesUsers(benchUsers);
    })
    .catch((error) => {
      setIsLoading(false);
      console.log("Error", error);
    });
};

const benchSalesOptions = [
  { value: "", label: "Select Bench Sales User" },
  ...benchSalesUsers.map((user) => ({
    value: user.email,
    label: `${user.firstName} ${user.lastName || ""}`,
  })),
];


const workAuthOptions = [
  { value: "", label: "Current Visa" },

  // Citizenship / Permanent
  { value: "US Citizen", label: "US Citizen" },
  { value: "Green Card", label: "Green Card" },
  { value: "GC EAD", label: "GC EAD" },
  // H Visa
  { value: "H1B", label: "H1B" },
  { value: "H4 EAD", label: "H4 EAD" },

  // L Visa
  { value: "L1", label: "L1" },
  { value: "L2 EAD", label: "L2 EAD" },

  // F Visa
  { value: "OPT", label: "OPT (F1)" },
  { value: "OPT EAD", label: "OPT EAD" },
  { value: "CPT", label: "CPT (F1)" },

  // Trade / NAFTA
  { value: "TN Visa", label: "TN Visa" },
  { value: "E3", label: "E3 (Australia)" },

  // Employment Authorization
  { value: "EAD", label: "EAD (General Work Authorization)" },
  { value: "Asylum EAD", label: "Asylum EAD" },
  { value: "Refugee EAD", label: "Refugee EAD" },
  // Fallback
  { value: "Other", label: "Other" },
];


// Entry Visa options
const entryVisaOptions = [
  { value: "", label: "First Entry Visa" },
  { value: "B1/B2", label: "B1/B2 (Visitor)" },
  { value: "F1", label: "F1 (Student)" },
  { value: "H1B", label: "H1B" },
  { value: "H4", label: "H4" },
  { value: "J1", label: "J1 (Exchange Visitor)" },
  { value: "L1", label: "L1" },
  { value: "L2", label: "L2" },
  { value: "Other", label: "Other" },
];
 
// Alphabetical sort (ignores first "placeholder" option)
const sortOptions = (options) => {
  const [first, ...rest] = options;
  return [first, ...rest.sort((a, b) => a.label.localeCompare(b.label))];
};
  const [years, setYears] = useState("");
  const [months, setMonths] = useState("");
  const handleExperienceChange = (y, m) => {
    setYears(y);
    setMonths(m);
    const expText = `${y ? y + " Years" : ""} ${m ? m + " Months" : ""}`.trim();
    setValue("experience", expText); // store combined value in RHF
  };

const [workAuth, setWorkAuth] = useState("");
const [entryDate, setEntryDate] = useState("");
const [entryVisa, setEntryVisa] = useState("");

const handleWorkAuthChange = (auth, date, visa) => { 
  setWorkAuth(auth);
  setEntryDate(date);
  setEntryVisa(visa);

  let text = auth || "";

  const parts = [];
  if (visa) parts.push(visa);
  if (date) parts.push(`on ${date}`);

  if (parts.length > 0) {
    text = `${auth} (First US Entry: ${parts.join(" ")})`;
  }

  setValue("WorkAuthorizationandValidity", text);
};



const handleShowModal = (docType) => {
  setSelectedDocType(docType);
  setShowModal(true);
};
const handleCloseModal = () => {
  setShowModal(false);
  setSelectedDocType(null);
};
const handleShowModal1 = async (docTypeKey, file) => {
  if (!file) return;

  const fileName = file.name.toLowerCase();

  if (fileName.endsWith(".docx")) {
    // convert DOCX to HTML
    try {
      const arrayBuffer = await file.arrayBuffer();
      const { value } = await mammoth.convertToHtml({ arrayBuffer });
      setModalContent({
        title: documentLabels[docTypeKey] || docTypeKey,
        html: value,
        url: null,
        file: file,
      });
    } catch (error) {
      console.error("DOCX preview error", error);
      setModalContent({
        title: documentLabels[docTypeKey] || docTypeKey,
        html: "<p>Failed to render DOCX preview.</p>",
        url: null,
        file: file,
      });
    }
  } else {
    const blobUrl = URL.createObjectURL(file);
    setModalContent({
      title: documentLabels[docTypeKey] || docTypeKey,
      url: blobUrl,
      html: null,
      file: file,
    });
  }

  setShowModal1(true);
};
const handleCloseModal1 = () => {
  setShowModal1(false);
};
const renderAttachment = (url, file, html) => {
  if (html) {
    // DOCX preview via mammoth
    return (
      <div
        style={{ maxHeight: "500px", overflowY: "auto" }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  if (!file) {
    return <div>File not found.</div>;
  }

  const name = file.name?.toLowerCase() || "";

  if (name.endsWith(".pdf")) {
    return (
      <iframe
        src={url}
        style={{ width: "100%", height: "500px", border: "none" }}
        title="PDF Preview"
      />
    );
  } else if (
    name.endsWith(".jpg") ||
    name.endsWith(".jpeg") ||
    name.endsWith(".png")
  ) {
    return <img src={url} alt="preview" style={{ maxWidth: "100%" }} />;
  }  else if (name.endsWith(".html") ||
    name.endsWith(".htm")) {
            return (
                <iframe
                    src={url}
                    title="HTML Attachment"
                    style={{ width: '100%', height: '500px', border: 'none' }}
                />
            );
        } else {
    return (
      <div>
        <p style={{ fontSize: 14 }}>
          Preview is not supported for this file type. Please
          <a href={url} download={file.name} style={{ marginLeft: 5 }}>
            download
          </a>
          .
        </p>
      </div>
    );
  }
};
const handleRemoveFile = (docTypeKey) => {
  const updatedFiles = { ...uploadedFiles };
  delete updatedFiles[docTypeKey];
  setUploadedFiles(updatedFiles);
};

const selectedJobRole = watch("JobRole");
const selectedVendorGuid = watch("VendorGuid");
useEffect(() => {
  if (selectedJobRole && selectedVendorGuid) {
    fetchJobPosts(parseInt(selectedJobRole), selectedVendorGuid);
  } else {
    setJobPosts([]); // clear if either is not selected
  }
}, [selectedJobRole, selectedVendorGuid]);

const fetchJobPosts = async (jobRoleId, vendorGuid) => {
  setIsLoading(true);
  try {
    const response = await Axios.get(`${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
                    { headers: { Authorization: `Bearer ${token}` } }
    );
// Filter based on selected Job Role and Vendor (client)
    const filteredPosts = response.data.filter((post) =>
      post.jobRoleID == jobRoleId && post.vGuid == vendorGuid&&
       post.status=="Active"
    );
        console.log(filteredPosts)

    setJobPosts(filteredPosts);
  } catch (error) {
    console.error("Error fetching job posts", error);
  } finally {
    setIsLoading(false);
  }
};



const fetchcoursesdata=()=>
    {
      const GetapiUrl=GetCourseInfo.APIURL;
      const fetchJSON = async () => {
        const response = await fetch(GetapiUrl);
        let json = await response.json();
        SetCourses(json);
       setValue("QualificationID",3)
       setValue("workMode","Hybrid")
       setValue("clientStatus","New")
      setValue("CandidateType","Internal Bench")
      }
      fetchJSON();
}

const GetVendorsList = () => {
  setIsLoading(true);

  const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;

  Axios.get(GetapiUrl)
    .then((result) => {
      setIsLoading(false);

      setVendorData(result.data);
    }).catch((error) => {
      console.log("Error" + error);
    });
};

const fetchcountries = () => {
  const GetapiUrl = GetCountries.APIURL;
  const fetchJSON = async () => {
    const response = await fetch(GetapiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`  // 👈 Authorization added
      }
    });

    let json = await response.json();
    SetCountries(json);
  };

  fetchJSON();
};

const fetchcodocumenttypes=()=>
  {
    const GetapiUrl=GetDocumentTypes.APIURL;
    const fetchJSON = async () => {
      const response = await fetch(GetapiUrl);
      let json = await response.json();
      SetDocuments(json);
    }
    fetchJSON();
}
let Guid="";

const guid = localStorage.getItem("guid");
const employerGuid = localStorage.getItem("employerGuid")
const email = localStorage.getItem("email")

const roleID = localStorage.getItem("roleID")

if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}

const FetchJobroles=()=>
  {
    const GetapiUrl= `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`; 
    const fetchJSON = async () => {
      const response = await fetch(GetapiUrl);
      let json = await response.json();
      SetJobRoles(json);
    }
    fetchJSON();
}

const jobPostOptions = jobPosts.map(job => ({
        label: job.title,
        value: job.jobPostID,
        jobDescription: job.jobDescription // Store job description for later use
      }));

const handleImageUpload = async (event) => {
  const file = event.target.files[0];
  setPhotoURL(file)
  setimgFile(URL.createObjectURL(file));
  var fileInput =document.getElementById('photo');
var filePath = fileInput.value;
       
// Allowing file type
var allowedExtensions =
      /(\.jpg|\.jpeg|\.png)$/i;

if (!allowedExtensions.exec(filePath)) {
Swal.fire({
  text: 'Invalid File Type!',
    })
 // toast.error('Issue with data format', {autoClose:500})
 
  fileInput.value = '';
  setimgFile("");
  
  return false;
}
else
{ 
setimgFile(URL.createObjectURL(event.target.files[0]));
return true;
} 

}

const saveCandidateAudio = async (candidateGuid, candidateName, audioFile) => {
  const audioFormData = new FormData();
  audioFormData.append("Guid", candidateGuid || null);
  audioFormData.append("CandidateName", candidateName || null);
  audioFormData.append("Audio", audioFile);
  audioFormData.append("AudioUrl", audioFile.name);
  audioFormData.append("FileId", "");

  try {
    await Axios.post(SaveCandidateRecordedAudio.APIURL, audioFormData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    console.error("Audio upload failed", error);
  }
};


const onSubmit = (data,e) => {
        e.preventDefault();
       if (!uploadedFiles.FileUrl) {
    Swal.fire({
      icon: "error",
      title: "Resume is required",
      text: "Please upload a Resume before submitting",
    });
          return;
        }
        setIsLoading(true);
      
       AddData(data)
    
    }
 const AddData= async(data)=>{
      // console.log(data.BillRate)
      const formData = new FormData();
      const response = await fetch(defaultimg);
      const imageBlob = await  response.blob();
       // Build Address from state + city
const address =`${selectedState} - ${selectedCity}`
    console.log(address)



       formData.append('UserGuid', Guid);
       formData.append("Address", address);
      formData.append('ProfileSummery', data.ProfileSummery);
      formData.append('Gender', data.gender);
      formData.append('MaritalStatus', data.maritalStatus);
    //  formData.append('ConsultantID',consultantDet[0].consultantID);
      formData.append('QualificationID', data.QualificationID);
      formData.append('Experience', data.experience);
      formData.append('MobileNumber', data.mobileNumber);
      formData.append('CurrentRole', "string");
      formData.append('CandidateType', data.CandidateType);
      formData.append('JobTitleID', data.jobPost ? data.jobPost?.value : "");
  // Resume string + file
formData.append(
  "Resume",
  uploadedFiles.FileUrl ? uploadedFiles.FileUrl.name : null
);
formData.append("FileUrl", uploadedFiles.FileUrl || null);

// VisaCopy string + file
formData.append(
  "VisaCopy",
  uploadedFiles.VisaCopyUrl ? uploadedFiles.VisaCopyUrl.name : null
);
formData.append("VisaCopyUrl", uploadedFiles.VisaCopyUrl || null);

// DrivingLicence string + file
formData.append(
  "DrivingLicence",
  uploadedFiles.DrivingLicenceUrl ? uploadedFiles.DrivingLicenceUrl.name : null
);
formData.append("DrivingLicenceUrl", uploadedFiles.DrivingLicenceUrl || null);

// Passport string + file
formData.append(
  "Passport",
  uploadedFiles.PassportURL ? uploadedFiles.PassportURL.name : null
);
formData.append("PassportURL", uploadedFiles.PassportURL || null);

// I94 string + file
formData.append(
  "I94",
  uploadedFiles.I94File ? uploadedFiles.I94File.name : null
);
formData.append("I94File", uploadedFiles.I94File || null);

// RTR PDF + file
formData.append(
  "RTR_PDF",
  uploadedFiles.RTR_PDFDoc ? uploadedFiles.RTR_PDFDoc.name : null
);
formData.append("RTR_PDFDoc", uploadedFiles.RTR_PDFDoc || null);
formData.append(
  "Resume_Insights_Pdf",
  uploadedFiles.Resume_Insights_Pdf ? uploadedFiles.Resume_Insights_Pdfdoc.name : null
);
formData.append("OthersDoc", uploadedFiles.OthersDoc || null);
formData.append(
  "Others",
  uploadedFiles.Others ? uploadedFiles.OthersDoc.name : null
);
formData.append("Resume_Insights_Pdfdoc", uploadedFiles.Resume_Insights_Pdfdoc || null);
      formData.append('HighestEducation', data.HighestEducation);
      formData.append ('Photo', data.photo);
      formData.append('PhotoURL', photoURL?photoURL:defaultimg);
      formData.append('WorkMode', data.workMode);
      formData.append('TechnicalSkill', data.technicalSkill);
      formData.append('DOB', data.dob);
      formData.append('FullName', data.fullName);
      formData.append('Email', data.email);
   formData.append(
  "PayRate",
  data.PayRate
    ? selectedCountry == 2
      ? `$${data.PayRate}`
      : `Rs.${data.PayRate}`
    : ""
);


formData.append("BillRate",  data.BillRate? selectedCountry == 2? `$${data.BillRate}`: `Rs.${data.BillRate}`
    : ""
);


      formData.append('WorkAuthorizationandValidity',  selectedCountry == 2 ? data.WorkAuthorizationandValidity : null);
      formData.append('EmployerName', data.EmployerName);
      formData.append('SSN', selectedCountry == 2 ? data.SSN : null );
      formData.append('PassportNo', selectedCountry == 2 ? data.PassportNo : null);
      formData.append('Tworefrencesfromrecentproject', data.Tworefrencesfromrecentproject);
      formData.append('Certifications', data.Certifications);
      formData.append('Comments', data.Comments);
      formData.append('Priority', data.Priority);
      formData.append('JobRole', data.JobRole);     
      formData.append('MaskedResume', data.MaskedResume);
      formData.append('MaskedFileUrl', maskedResumeCopy);      
      formData.append('LinkedInUrl', data.LinkedInUrl);
      formData.append('AvailabilityToInterview', data.AvailabilityToInterview);
      formData.append('AvailabilityToJoin', data.AvailabilityToJoin);
      formData.append('WillingToRelocate', data.WillingToRelocate);
      formData.append('VendorGuid', data.VendorGuid);
      formData.append('clientStatus', data.clientStatus);
      formData.append('CreatedBy', email);    
      formData.append("CountryID", selectedCountry);
      formData.append('PreferLocation', selectedCountry);
      formData.append('SubmittedBy', email);
      formData.append('CustomAssessmentLink',data.customAssessmentLink)
      formData.append('SkillMetrics',data.SkillMetrics)
      formData.append('assignBenchSaleUser',data.assignBenchSaleUser)
      formData.append('marketingStatus',data.marketingStatus || 'Active')

      const apiAddUrl = AddBenchCandidatesProfile.APIURL;

       Axios.post(apiAddUrl,formData)
       .then(async (result)=>{
         setIsLoading(false)
          if (result.data.message === "Record created successfully") 
               { 
                  const newCandidateGuid = result.data.guid;
                    //alert("created");
                 Swal.fire({
                   position: 'center',
                   icon: 'success',
                   title: 'Record created successfully ',
                   showConfirmButton: false,
                   timer: 5000
                 })
              if (assessmentMode === "file" && assessmentFile) {
                await saveCandidateAudio(newCandidateGuid, data.fullName, assessmentFile);
              }
                 navigate("/Employer/InternalBench")
                    reset();         
               }
               else if (result.data.message===`This Candidate already registered with the ${data.email}`){
                Swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: `This Candidate already registered with the ${data.email}`,
                  showConfirmButton: false,
                  timer: 7000
                })
               }
               else if(result.data.message === " Input data having some issues")
               { 
                 Swal.fire({
                   position: 'center',
                   icon: 'error',
                   title: 'Not Submitted',
                   showConfirmButton: false,
                   timer: 7000
                 })
                 
              // toast.error('Issue with data format', {autoClose:5000})
               }
               
       })
         .catch(()=>{
           setIsLoading(false)
           Swal.fire({
             position: 'center',
             icon: 'error',
             title: 'Something went wrong try again',
             showConfirmButton: false,
             timer: 7000
           })
         })
         }   
       
         const jobTitleOptions = jobPosts.map(job => ({
        value: job.jobPostID,
        label: `${job.title} - ${job.clientName}`,
        jobDescription: job.jobDescription ,// Store job description for later use
        billRate: job.billRate,
      }));

 const [skills, setSkills] = useState([
    { Skill: "", YearsOfExp: "", Rating: "" },
  ]);

  // Handle input change
  const handleChange = (index, field, value) => {
    const updated = [...skills];
    updated[index][field] = value;
    setSkills(updated);

    // Keep API value updated as stringified JSON
    setValue("SkillMetrics", JSON.stringify(updated));
  };

  // Add new row
  const handleAdd = () => {
    setSkills([...skills, { Skill: "", YearsOfExp: "", Rating: "" }]);
  };

  // Delete row
  const handleDelete = (index) => {
    const updated = skills.filter((_, i) => i !== index);
    setSkills(updated);
    setValue("SkillMetrics", JSON.stringify(updated));
  };
const [selectedState, setSelectedState] = useState("");
const [selectedCity, setSelectedCity] = useState("");
const [cities, setCities] = useState([]);

const handleStateChange = (stateValue) => {
  let cityList = [];

  if (selectedCountry == 1) {
    // India
    cityList = IndiaStateCities[stateValue] || [];
  } else {
    // US
    cityList = usStateCities[stateValue] || [];
  }

  setCities(cityList);
};

    useEffect(()=>{
      fetchcoursesdata();
      GetVendorsList();
      FetchJobroles();
      fetchcountries();
      fetchcodocumenttypes();
       setCities([]);
  setSelectedCity(""); 
 GetUsersList();
  },[selectedCountry])
 return(
   <ConsultantLayout>
  <section>
  {
  isLoading ? <center> <LoadingSpinner /> </center> : 
  <div className="container-fluid mt-4 pb-5">
         <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/InternalBench">
    <i className="fa  fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Add Internal Candidate</h2>
</div>

<hr/>
     <div className="bg-gray mt-4">
      
        <form onSubmit={handleSubmit(onSubmit)} id="loginform">
       
       <div class="row p-3">
<div className="col-sm-12 col-lg-2 col-xl-2 col-md-2">
<div className="upload-btn-wrapper text-center"> 
         
<label htmlFor="photo" style={{ cursor: 'pointer' }}>
        <img src={imgfile?imgfile: defaultimg} alt="Upload Image" style={{cursor:"pointer",  borderRadius: '50%',
            width: '100px',
            height: '100px',}} />
        <input
          type="file"
          id="photo"
          style={{ display: 'none' }}
          {...register('photo', { onChange: handleImageUpload })}
        />
       
      </label>
            

          </div>

</div>
<div className="col-sm-12 col-xl-5 col-lg-5 col-md-5">
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>  
          <input type="text" title='' placeholder='Full Name' {...register("fullName", { required: "Fullname Required" })} id="fullName" name="fullName" 
           disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.fullName ? 'is-invalid' : ''}`}
                      />
        </OverlayTrigger>
        <div className="invalid-feedback"> {errors.fullName?.message}</div>

        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>    
   
   <input 
                placeholder='Mobile Number'
                type="Number"
                min="0"
                title=''
                name="mobileNumber"
                disabled={isDisabled}
                {...register("mobileNumber", { required: "Mobile Number Required" })}
                className={`form-control basic-form mt-3 ${errors.mobileNumber ? 'is-invalid' : ''}`}
            />
      </OverlayTrigger>
      <div className="invalid-feedback"> {errors.mobileNumber?.message}</div>

      <div class="mb-2 mt-4" style={{fontSize:12, color:"#495057" }}>
          <label >Gender</label>

          </div>
          <input 
        {...register("gender", { required: true })}
        type="radio"
        name="gender"
        value="Male"
        id="field-male"
        disabled={isDisabled}
         defaultChecked
      /> 
      <label style={{ fontSize: 13, color: "#495057", marginRight:'30px',marginLeft:'10px' }}>Male</label>
      
      <input  
        {...register("gender", { required: true })}
        type="radio"
        name="gender"
        value="Female"
        id="field-female"
        disabled={isDisabled}
      />
      <label style={{ fontSize: 13, color: "#495057", marginLeft: 10 }}>Female</label>
      
      {errors.gender && <div style={{color:"#dc3545",fontSize:"80%"}}>Gender required</div>}
      
    
            

<div class="mb-2 mt-4" style={{fontSize:12, color:"#495057"}}>
          <lable >Marital Status</lable>
          </div>
        <input
                     {...register("maritalStatus")}
                     type="radio"
                     name="optionalField"
                     title='maritalStatus'
                     value="married"
                     id="maritalStatus"
                     disabled={isDisabled}
                     className="mr-2"
                     defaultChecked
                 /><label style={{fontSize : 13,color:"#495057"}}>Married</label>
                  &nbsp;&nbsp;
                  <input 
                     {...register("maritalStatus")}
                     type="radio"
                     name="optionalField"
                     title='maritalStatus'
                     value="unmarried"
                     id="field-female"
                     
                     disabled={isDisabled}
                 /><label style={{fontSize : 13, color:"#495057", marginLeft : 10}}>Unmarried</label>

             
                     <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Education</Tooltip>)}>    

<select  {...register("QualificationID", { required: "Education Required" })} className={`form-control mt-3 ${errors.QualificationID ? 'is-invalid' : ''}`}style={{height:50 ,borderRadius:15,fontSize:12}}  >
<option value="">Select Education</option>
{
  Courses.map((item,index)=>
  {
    return(

   <option key={index}  value={item.qualificationID}>{item.courseName}</option>

    );
  }
  
  )
}
</select>
</OverlayTrigger>
<div className="invalid-feedback"> {errors.QualificationID?.message}</div>
   <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Highest Education</Tooltip>)}>  
                      <input type="text" title='' placeholder='Highest Education' {...register("HighestEducation")} id="HighestEducation" name="HighestEducation" 
                      disabled={isDisabled} className={`form-control basic-form mt-3`}
                                  />
                    </OverlayTrigger>

                
                  <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>{payRatePlaceholder}</Tooltip>)}> 
      <input type={selectedCountry == 2 ? "number" : "text"} name="PayRate" {...register("PayRate")} placeholder={payRatePlaceholder}className={`form-control basic-form mt-3`} />
      </OverlayTrigger>
        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> {billRatePlaceholder} </Tooltip>)}>  
                    <input type={selectedCountry == 2 ? "number" : "text"} placeholder={billRatePlaceholder}{...register("BillRate")} id="BillRate" name="BillRate" 
                    disabled={isDisabled} className={`form-control basic-form mt-3 `}
                                />
       </OverlayTrigger>
   {selectedCountry == 2 && (
  <div className="d-flex gap-2 mt-3">

    {/* Current Visa */}
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="tooltip-workauth">Current Visa</Tooltip>}
    >
      <select
        className="form-control"
        style={{ height: 50 }}
        value={workAuth}
        onChange={(e) => handleWorkAuthChange(e.target.value, entryDate, entryVisa)}
      >
        {sortOptions(workAuthOptions).map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </OverlayTrigger>

    {/* First US Entry Visa */}
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="tooltip-entry-visa">First US Entry Visa Type</Tooltip>}
    >
      <select
        className="form-control"
        style={{ height: 50 }}
        value={entryVisa}
        onChange={(e) =>
          handleWorkAuthChange(workAuth, entryDate, e.target.value)
        }
      >
        {sortOptions(entryVisaOptions).map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </OverlayTrigger>

    {/* First US Entry Date */}
    <OverlayTrigger
  placement="bottom"
  overlay={<Tooltip id="tooltip-year">First US Entry Year</Tooltip>}
>
  <select
    className="form-control"
    style={{ height: "50px" }}
    value={entryDate}
    onChange={(e) => handleWorkAuthChange(workAuth, e.target.value, entryVisa)}
  >
    <option value="">Select Year</option>
    {Array.from({ length: new Date().getFullYear() - 1969 }, (_, i) => {
      const year = new Date().getFullYear() - i;
      return (
        <option key={year} value={year}>
          {year}
        </option>
      );
    })}
  </select>
</OverlayTrigger>
 

    <input
      type="hidden"
      {...register("WorkAuthorizationandValidity")}
    />
  </div>
)}

                  <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> EmployerName</Tooltip>)}>  
                    <input type="text" title='' placeholder='Employer Name' {...register("EmployerName")} id="EmployerName" name="EmployerName" 
                    disabled={isDisabled} className={`form-control basic-form mt-3`}
                                />
                  </OverlayTrigger>
               {selectedCountry == 2 &&  ( <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> SSN</Tooltip>)}>    
            
                  <input 
                  placeholder='Enter last 4 digits of SSN'
                  type="number"
                  name="SSN"
                  {...register("SSN", { 
                    validate: value => {
                      // Check if value is empty
                      if (!value) return true;
                      // Check if value is exactly 4 digits
                      const valueStr = value.toString();
                      if (valueStr.length !== 4) {
                        return "SSN must be exactly 4 digits";
                      }
                      return true;
                    }
                  })}
                  className={`form-control basic-form mt-3`}
                  onInput={(e) => {
                    if (e.target.value.length > 4) {
                      e.target.value = e.target.value.slice(0, 4);
                    }
                  }}
                />
                  </OverlayTrigger>)}
      
                  {selectedCountry == 2 &&  (    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Passport Number</Tooltip>)}>  
                      <input type="text" title=''  name="optionalField" placeholder='Passport Number' {...register("PassportNo")} id="PassportNo"  
                      className={`form-control basic-form mt-3`}
                                  />
                    </OverlayTrigger>)}
      
                    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Certifications</Tooltip>)}>  
                      <input type="text" title='' placeholder='Certifications' {...register("Certifications")} id="Certifications" name="Certifications" 
                      disabled={isDisabled} className={`form-control basic-form mt-3`}
                                  />
                    </OverlayTrigger>
        
                      <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Job Role</Tooltip>)}>    

<select  {...register("JobRole", { required: "Job Role Required" })} className={`form-control mt-3 ${errors.JobRole ? 'is-invalid' : ''}`} style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Job Role</option>
{
  jobRoles.map((item,index)=>
  {
    return(

   <option key={index}  value={item.jobRoleId}>{item.jobRole}</option>

    );
  }
  
  )
}
</select>
</OverlayTrigger>
<div className="invalid-feedback"> {errors.JobRole?.message}</div>

                     <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Select Client
</Tooltip>)}>
<select  {...register("VendorGuid")} className={`form-control mt-3`}style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Client</option>
{
  vendorData.map((item,index)=>
  {
    return(

   <option key={index}  value={item.vGuid}>{item.vendorName} - {item.vendorCompanyName}</option>

    );
  }
  
  )
}
</select>
</OverlayTrigger>                 

<OverlayTrigger
  placement="bottom"
  overlay={(props) => <Tooltip id="tooltip" {...props}>Select Job Title</Tooltip>}
>
  <div className="mt-4">
    <Controller
      name="jobPost"
      control={control}
      render={({ field }) => (
        <Select
          {...field}
          options={jobTitleOptions}
          placeholder="Select Job Title"
          className={`basic-form ${errors.jobPost ? 'is-invalid' : ''}`}
          styles={{
            control: (provided) => ({
              ...provided,
              height: 50,
              borderRadius: 15,
              fontSize:12,
              borderColor: errors.jobPost ? 'red' : provided.borderColor
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 9999, // Ensures dropdown appears above everything
              position: "absolute" // Fixes layout issues
            })
          }}
         
      
          // Store the entire selected option object
          onChange={(selectedOption) => {
            field.onChange(selectedOption); // Save the full selected option
            setValue("JobTitleID", selectedOption.jobPostID);
             const rate = selectedOption?.billRate;
             const normalizedRate = typeof rate === "string" ? rate.replace(/[^0-9.]/g, "") : (rate ?? "");
             setValue("BillRate", normalizedRate)
          }}
          value={jobPostOptions.find(option => option.value === field.value)}
        />
      )}
    />
    {errors.jobPost && <div className="invalid-feedback d-block">{errors.jobPost.message}</div>}
  </div>
</OverlayTrigger>
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Select Candidate Type
</Tooltip>)}>
<select  {...register("CandidateType")} className={`form-control mt-3`}style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Candidate Type</option>
{
  candidateType.map((item,index)=>
  {
    return(

   <option key={index}  value={item.candidateTypeID}>{item.candidateTypeID}</option>

    );
  }
  
  )
}
</select>
</OverlayTrigger>
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Candidate Status</Tooltip>)}>
<select  {...register("clientStatus")} className={`form-control mt-3`}style={{height:50 ,borderRadius:15,fontSize:12}}  >
<option value="">Select Candidate Status</option>
<option value="New">New</option>
<option value="Submitted">Submitted</option>
{/* '<option value="In-Progress">In-Progress</option>
<option value="Interview Scheduled">Interview Scheduled</option>
<option value="On Hold">On-Hold</option>
<option value="Selected">Selected</option>
<option value="Rejected">Rejected</option>' */}
</select>
</OverlayTrigger>
<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Custom Assessment Link</Tooltip>}>
  <input
    type="text"
    className="form-control mt-3"
    placeholder="Enter / Upload Custom Assessment"
    onClick={() => setShowAssessmentModal(true)}   // 👈 use onClick, not onFocus
    value={
      assessmentMode === "link"
        ? watch("customAssessmentLink")
        : assessmentMode === "file"
        ? (assessmentFile?.name || "")
        : ""
    }
    readOnly  // 👈 prevents cursor/focus
  />
</OverlayTrigger>


   
<label className="mt-3" style={{ fontSize: "12px" }}>
  Skill Metrics
</label>
  {skills.map((skill, index) => {
  const hideDelete =
    skills.length === 0 || isEmptySkill(skill);

  return (
    <div key={index} className="d-flex gap-2 mb-2 align-items-center mt-2">
      
      <input
        type="text"
        className="form-control"
        placeholder="Skill"
        value={skill.Skill || ""}       
        onChange={(e) => handleChange(index, "Skill", e.target.value)}
      />

      <input
        type="text"
        className="form-control"
        placeholder="No.of Years Exp"
        value={skill.YearsOfExp || ""}
        onChange={(e) => handleChange(index, "YearsOfExp", e.target.value)}
      />

      <input
        type="number"
        className="form-control"
        placeholder="Rating (1-5)"
        min="1"
        max="5"
        value={skill.Rating || ""}
        onChange={(e) => handleChange(index, "Rating", e.target.value)}
      />

      {/* ❌ Delete Button (conditionally hidden) */}
      { !hideDelete && (
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => handleDelete(index)}
        >
          <i className="fa fa-trash"></i>
        </button>
      )}

      {/* ➕ Add Button only on last row */}
      {index === skills.length - 1  && (
        <button
          type="button"
          className="btn btn-success"
          onClick={handleAdd}
        >
          <i className="fa fa-plus"></i>
        </button>
      )}
    </div>
  );
})}


      {/* Hidden input for API */}
      <input type="hidden" {...register("SkillMetrics")} />
</div>


  



<div  className="col-sm-12 col-xl-5 col-lg-5 col-md-5">




<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Email</Tooltip>)}> 
          <input type="text"  placeholder='Email' id="email" name="email" {...register("email" , { required: "Email Required" })} 
           disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.email ? 'is-invalid' : ''}`}

          />
          </OverlayTrigger>
          <div className="invalid-feedback"> {errors.email?.message}</div>

          <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Date of Birth</Tooltip>)}>
        <input type="date" pattern="/^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/"   name="dob"
         {...register("dob")}
         className={`form-control basic-form mt-3 `} placeholder="Date of birth" aria-label="Username"/>
        </OverlayTrigger>
 <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Profile Summary</Tooltip>)}>  
          <textarea type="text" style={{height:100}} title='' placeholder='Profile Summary' {...register("ProfileSummery")} id="ProfileSummery" name="ProfileSummery" 
           disabled={isDisabled} className={`form-control basic-form mt-3 `}
                      />
        </OverlayTrigger>

 <div className="d-flex gap-2 mt-3">
  {/* State Dropdown */}
  <select
  name="state"
  className="form-control mt-3"
  value={selectedState}   // <-- bind to state
  onChange={(e) => {
    setSelectedState(e.target.value);   // <-- update state
    handleStateChange(e.target.value);  // <-- still trigger city fetch
  }}
>
  <option value="">Select State</option>
  {selectedCountry == 1
    ? IndiaStates.map((s) => (
        <option key={s.value} value={s.value}>
          {s.label}
        </option>
      ))
    : usStates.map((s) => (
        <option key={s.value} value={s.value}>
          {s.label}
        </option>
      ))}
</select>

  {/* City Dropdown */}
  <select
  name="city"
  className="form-control mt-3"
  value={selectedCity}
  onChange={(e) => setSelectedCity(e.target.value)}
  disabled={cities.length === 0}
>
  <option value="">Select City</option>
  {cities
    .slice() // make a copy to avoid mutating state
    .sort((a, b) => a.localeCompare(b)) // sort alphabetically
    .map((city, i) => (
      <option key={i} value={city}>
        {city}
      </option>
    ))}
</select>


</div>




           <div className="d-flex gap-2 mt-3">
  {/* Years Dropdown */}
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-years">Years of Experience</Tooltip>}
  >
    <select
      className={`form-control ${errors.experience ? "is-invalid" : ""}`}
      value={years}
      style={{height:50}}
      onChange={(e) => handleExperienceChange(e.target.value, months)}
    >
      <option value="">Years</option>
      {[...Array(51).keys()].map((y) => (
        <option key={y} value={y}>{y}</option>
      ))}
    </select>
  </OverlayTrigger>

  {/* Months Dropdown */}
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-months">Months of Experience</Tooltip>}
  >
    <select
      className={`form-control ${errors.experience ? "is-invalid" : ""}`}
     style={{height:50}}
      value={months}
      onChange={(e) => handleExperienceChange(years, e.target.value)}
    >
      <option value="">Months</option>
      {[...Array(12).keys()].map((m) => (
        <option key={m} value={m}>{m}</option>
      ))}
    </select>
  </OverlayTrigger>
</div>


      {/* Hidden field to actually store combined value */}
      <input
        type="hidden"
        {...register("experience", { required: "Experience Required" })}
      />

      <div className="invalid-feedback">{errors.experience?.message}</div>
            
                     
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Key Skills</Tooltip>)}> 
<div>
<textarea type="text" style={{height:100}} id="technicalSkill" name="technicalSkill" {...register("technicalSkill", { required: "KeySkills Required" })} placeholder="Enter Key Skills " className={`form-control basic-form mt-3 ${errors.technicalSkill ? 'is-invalid' : ''}`} />

</div>
</OverlayTrigger> 

<div className="invalid-feedback"> {errors.technicalSkill?.message}</div>

<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Work Mode</Tooltip>)}>    

<select  {...register("workMode", { required: "Work Mode Required" })} className={`form-control mt-3 ${errors.workMode ? 'is-invalid' : ''}`} style={{height:50,borderRadius:15,fontSize:12}}  >
<option value="">Select Work Mode </option>
{
workmode.map((item,index)=>
{
return(

<option key={index}  value={item.statusName}>{item.statusName}</option>

);
}

)
}
</select>
</OverlayTrigger>
{ <div className="invalid-feedback">{errors.workMode?.message}</div> }



        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Comments </Tooltip>)}> 
      <input type="text" name="Comments" {...register("Comments")} placeholder="Comments"
      className={`form-control basic-form mt-3 `}/>
      </OverlayTrigger>
            <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Priority</Tooltip>)}> 
      <input type="text" name="Priority" {...register("Priority")} value={1} placeholder="Priority " 
      className={`form-control basic-form mt-3 `} />
      </OverlayTrigger>
       <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Two References from Recent Project</Tooltip>)}>  
                      <input type="text" title='' placeholder='Two References from Recent Project' {...register("Tworefrencesfromrecentproject")} id="Tworefrencesfromrecentproject" name="Tworefrencesfromrecentproject" 
                      disabled={isDisabled} className={`form-control basic-form mt-3`}
                                  />
                    </OverlayTrigger>
     
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>LinkedIn Url</Tooltip>)}>  
          <input type="text" title='' placeholder='LinkedIn Url' {...register("LinkedInUrl")} id="LinkedInUrl" name="LinkedInUrl" 
           className={`form-control basic-form mt-3 `}/>
        </OverlayTrigger>     


   
    <div class="mb-2 mt-4" style={{fontSize:12, color:"#495057"}}>
              <lable >Willing to Relocate</lable>
              </div>
          <input
  {...register("WillingToRelocate")}
  type="radio"
  name="WillingToRelocate"  // ✅ Correct
  value="Yes"
  id="WillingToRelocate"
  disabled={isDisabled}
  className="mr-2"
/>
<label style={{ fontSize: 13, color: "#495057" }}>Yes</label>

&nbsp;&nbsp;

<input
  {...register("WillingToRelocate")}
  type="radio"
  name="WillingToRelocate"  // ✅ Correct
  value="No"
  id="WillingToRelocateNo"
  disabled={isDisabled}
/>
<label style={{fontSize : 13, color:"#495057", marginLeft : 10}}>No</label>
    
                 <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Availability to Interview</Tooltip>)}>  
          <input type="text" title='' placeholder='Availability to Interview' {...register("AvailabilityToInterview")} id="AvailabilityToInterview" name="AvailabilityToInterview" 
           className={`form-control basic-form mt-3 `}/>
        </OverlayTrigger> 
        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Availability for Joining</Tooltip>)}>  
          <input type="text" title='' placeholder='Availability for Joining' {...register("AvailabilityToJoin")} id="AvailabilityToJoin" name="AvailabilityToJoin" 
           className={`form-control basic-form mt-3 `}/>
        </OverlayTrigger> 
        <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Marketing Status</Tooltip>)}>    

<select  {...register("marketingStatus")} className={`form-control mt-3`} style={{height:50,borderRadius:15,fontSize:12}}  >
<option value="">Select Marketing Status </option>
{
marketingStatus.map((item,index)=>
{
return(

<option key={index}  value={item.statusName}>{item.statusName}</option>

);
}

)
}
</select>
</OverlayTrigger>

         <OverlayTrigger
  placement="bottom"
  overlay={<Tooltip>Assign Bench Sales User</Tooltip>}
>
  <div className="mt-3">
    <Controller
      name="assignBenchSaleUser"
      control={control}
      render={({ field }) => (
        <Select
          {...field}
          options={benchSalesOptions}
          placeholder="Select Bench Sales User"
          value={benchSalesOptions.find(
            (opt) => opt.value === field.value
          )}
          onChange={(selected) => field.onChange(selected.value)}
          styles={{
            control: (base) => ({
              ...base,
              height: 50,
              borderRadius: 15,
              fontSize: 12,
            }),
          }}
        />
      )}
    />
  </div>
</OverlayTrigger>

<br/>  
    <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Upload Documents
</Tooltip>)}>
<select 
  onChange={(e) => {
    setSelectedDocType(e.target.value);

    handleShowModal(e.target.value);  // open modal
     e.target.value ="";
  }}
className={`form-control `}style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Any Document</option>
{

  documents.map((item,index)=>
  {
    return(

   <option key={index}  value={item.documentType}>{item.documentType}</option>

    );
  }
  
  )
}
</select>
                     </OverlayTrigger>
                    
                   <div>
 {Object.keys(uploadedFiles).map((docTypeKey) => {
  const file = uploadedFiles[docTypeKey];
  const displayLabel = documentLabels[docTypeKey] || docTypeKey; // fallback
  return (
 <div key={docTypeKey}>
  <strong style={{ fontSize: 12 }}>{displayLabel} :</strong> &nbsp;
  <span style={{ fontSize: 12 }}>{file.name}</span>
  &nbsp; | &nbsp;
  <button
  type="button"
  style={{
    border: "none",
    background: "transparent",
    color: "blue",
    fontSize: 12,
    cursor: "pointer"
  }}
  onClick={() => handleShowModal1(docTypeKey, file)}
>
  View
</button>
  &nbsp; | &nbsp;
  <button
    type="button"
    style={{
      border: "none",
      background: "transparent",
      color: "red",
      fontSize: 12,
      cursor: "pointer"
    }}
    onClick={() => handleRemoveFile(docTypeKey)}
  >
    Remove
  </button>
  
</div>

  );
})}


              </div>

</div>


</div>

 
 <div class="row mb-4 mt-3 ">
    <div class="col-12">  
    
            
               </div>
               </div>
               <Link to="/Employer/InternalBench"> 
                <button  style={{float:"right"}}  disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                  Cancel
                </button>
                </Link>
       <button id="svbutton" style={{float:"right"}} disabled={isSubmitting || isDisabled } className="btn btn-primary pf-save mb-3 mr-3" >
                     {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                     Save
                 </button> &nbsp;&nbsp;&nbsp;
     
     </form>
    

   </div>

</div>

 }

<Modal show={showModal} onHide={handleCloseModal}>
  <Modal.Header closeButton>
    <Modal.Title style={{color:"#00a7ac"}}>Upload {selectedDocType}</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{height:100}}>
    <input type="file" accept=".pdf,.jpg,.jpeg,.png,.docx" 

      style={{fontSize:18,color:"#00a7ac"}}
      onChange={(e) => {
        const file = e.target.files[0];
        if (!file) return;

        const originalFileName = file.name;
        // replace special characters
        const sanitizedFileName = originalFileName.replace(/[^a-zA-Z0-9.\-_]/g, "_");

        // allow only PDF, DOC, DOCX
        const allowedExtensions = /\.(pdf|doc|docx|jpg|jpeg|png|html)$/i;
        if (!allowedExtensions.test(sanitizedFileName)) {
          Swal.fire({
            icon: "error",
            text: "Invalid file type. Only PDF, DOC, or DOCX allowed.",
          });
          e.target.value = "";
          return;
        }

        // create new file with sanitized name
        const renamedFile = new File([file], sanitizedFileName, { type: file.type });

        let fileField = "";
        switch (selectedDocType) {
          case "Resume":
            fileField = "FileUrl";
            break;
          case "Visa Copy":
            fileField = "VisaCopyUrl";
            break;
          case "Driving Licence":
            fileField = "DrivingLicenceUrl";
            break;
          case "Passport":
            fileField = "PassportURL";
            break;
          case "I-94":
            fileField = "I94File";
            break;
              case "RTR_PDF":
            fileField = "RTR_PDFDoc";
            break;
             case "Resume_Insights_Pdf":
            fileField = "Resume_Insights_Pdfdoc";
            break;
             case "Others":
            fileField = "OthersDoc";
            break;
          default:
            fileField = `${selectedDocType}Url`;
        }

        setUploadedFiles((prev) => ({
          ...prev,
          [fileField]: renamedFile,
        }));

        handleCloseModal();
        setSelectedDocType("");
      }}
    />
  </Modal.Body>
</Modal>
<Modal show={showModal1} onHide={handleCloseModal1} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>{modalContent.title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {renderAttachment(modalContent.url, modalContent.file, modalContent.html)}
  </Modal.Body>
</Modal>
<Modal show={showAssessmentModal} onHide={() => setShowAssessmentModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Custom Assessment Link</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {!assessmentMode && (
      <div className="d-flex flex-column gap-3">
        <button className="btn btn-outline-primary" onClick={() => setAssessmentMode("link")}>
          Enter Link Directly
        </button>
        <button className="btn btn-outline-secondary" onClick={() => setAssessmentMode("file")}>
          Upload File
        </button>
      </div>
    )}

    {assessmentMode === "link" && (
      <input
        type="text"
        className="form-control"
        placeholder="Enter Custom Assessment Link"
        {...register("customAssessmentLink")}
      />
    )}

    {assessmentMode === "file" && (
      <input
        type="file"
        accept="audio/*,.pdf,.doc,.docx,video/mp4,video/webm"
        className="form-control"
        onChange={(e) => setAssessmentFile(e.target.files[0])}
      />
    )}
  </Modal.Body>
  <Modal.Footer>
    <button className="btn btn-secondary" onClick={() => {
      setAssessmentMode("");
      setShowAssessmentModal(false);
    }}>
      Close
    </button>
    <button className="btn btn-primary" onClick={() => setShowAssessmentModal(false)}>
      Done
    </button>
  </Modal.Footer>
</Modal>



 </section>
</ConsultantLayout>

    )
}
export default AddInternalCandidate;